module.exports = __webpack_public_path__ + "public/img/cmwlwv.97162a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/cmwlwv.png
// module id = MHNd
// module chunks = 1